export function getDominantColor(imageUrl) {
    const image = document.createElement('img'); 
    image.setAttribute('src', imageUrl);

    if (image.width) {
        return Promise.resolve(processLoadedImage(image));
    }
    else {
        return new Promise(resolve => {
            image.addEventListener('load', () => {
                resolve(processLoadedImage(image));
            });
        })
    }
}

function processLoadedImage(image) {
    const imageData = getPixels(image);

    if (imageData) {
        const sampledPixels  = sampleTopBottomEdges(imageData);
        return simpleAverage(sampledPixels);
    } else {
        return false;
    }
}

function getPixels(img) {
    try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;

        var context = canvas.getContext('2d');
        context.drawImage(img, 0, 0);

        return context.getImageData(0, 0, canvas.width, canvas.height);
    } catch (e) {
        // probably local file security error
    }
}

function sampleTopBottomEdges (imageData) {
    const pixelsPerEdge = 6;
    const pixels = [];

    for (let x = 0, max = imageData.width, step = Math.floor(max / pixelsPerEdge); x < max; x += step) {
        pixels.push(getPixel(imageData, x, 0));
        pixels.push(getPixel(imageData, x, imageData.height - 1));
    }
    
    return pixels;
}

function getPixel(imageData, x, y) {
    const start = (y * imageData.width + x) * 4;
    return imageData.data.slice(start, start + 4);
} 

function simpleAverage(pixels) {
    let num = 0;
    const sum = [0, 0, 0, 0];

    for (let i = 0, length = pixels.length; i < length; i++) {
        var pixel = pixels[i];
        if (!pixel[3]) {
            continue;
        };

        sum[0] += pixel[0];
        sum[1] += pixel[1];
        sum[2] += pixel[2];
        sum[3] += pixel[3];
        num++;
    }

    if (num) {
        sum[0] /= num;
        sum[1] /= num;
        sum[2] /= num;
        sum[3] /= num;
    }
    sum[3] = sum[3] || 255;

    return { 
        r: sum[0],
        g: sum[1],
        b: sum[2],
        a: sum[3] / 256
    };
};
